import { z } from 'zod';

const metric = z.union([z.number(), z.string().trim().min(1)]).transform(Number).refine(Number.isFinite);
const count = metric.refine(value => Number.isInteger(value) && value >= 0);
const percent = metric.refine(value => value >= 0 && value <= 100);
const date = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const dashboardKPIsSchema = z.object({
  totalMembers: count, classesToday: count, totalBookings: count, revenue: metric,
  newMembers: count, renewals: count, averageOccupation: percent, retentionRate: percent.nullable(),
  memberBookings: count.optional(), trialBookings: count.optional(), renewalMembers: count.optional(),
  businessTimeZone: z.enum(['Africa/Tunis', 'Asia/Riyadh']).optional(),
}).refine(data => (data.memberBookings === undefined && data.trialBookings === undefined) ||
  (data.memberBookings !== undefined && data.trialBookings !== undefined && data.totalBookings === data.memberBookings + data.trialBookings), 'Inconsistent booking breakdown');
export const dashboardBookingsSchema = z.object({
  data: z.array(z.object({ booking_date: date, booking_count: metric })),
  bookingScope: z.literal('calendar').optional(),
});
export const dashboardHeatmapSchema = z.object({ data: z.array(z.object({
  day: metric, hour: metric, bookings: metric, avgCapacity: metric, occupationRate: metric,
})) });
export const dashboardGrowthSchema = z.object({ data: z.array(z.object({
  month: date, members_count: metric, revenue: metric, previous_members_count: metric, previous_revenue: metric,
})) });
export const dashboardMemberEvolutionSchema = z.object({ points: z.array(z.object({
  bucket: date, new_members: metric, renewals: metric,
})) });
export const dashboardInsightsSchema = z.object({ data: z.array(z.object({
  type: z.string(), title: z.string(), description: z.string(), data: z.unknown(),
})) });
export const dashboardCoachPerformanceSchema = z.object({ data: z.array(z.object({
  coach_id: z.string(), coach_name: z.string(), classes_count: metric, total_bookings: metric,
  avg_occupation: metric, total_revenue: metric,
})) });
export const dashboardCancellationSchema = z.object({ data: z.array(z.object({
  class_name: z.string(), total_bookings: metric, cancelled_bookings: metric, no_show_rate: metric,
})) });
export const dashboardRatingSchema = z.object({ data: z.array(z.object({
  instructor: z.string(), month: date, avg_rating: metric, total_ratings: metric,
})) });
export const dashboardPopularClassesSchema = z.object({ data: z.array(z.object({
  class_name: z.string(), booking_count: metric,
})) });